import ky from 'ky';

export default {
  namespace: true,
  state: {
    vehicleChartData: [],
    vehicleCategories: [],
    loadingVehicleChart: false,
  },
  getters: {
    getSelectedVehicleType: (state, getters, rootState) => {
      if (rootState.route.query && rootState.route.query.vehicle_type !== undefined) {
        return rootState.route.query.vehicle_type;
      }
      return 'freight';
    },
    getVehicleChartData: (state) => state.vehicleChartData,
    getVehicleCategories: (state) => state.vehicleCategories,
  },
  mutations: {
    setLoadingVehicleChart(state, status) {
      state.loadingVehicleChart = status;
    },
    setVehicleData(state, vehicleInfo) {
      const selectedVehicleData = vehicleInfo.data[vehicleInfo.dataType][vehicleInfo.query];
      const vehicleTypes = selectedVehicleData.vehicle_vocation;
      const classChart = {
        nonroad: {
          name: 'Non-road',
          color: '#012130',
        },
        8: {
          name: 'Class 8',
          color: '#00354E',
        },
        7: {
          name: 'Class 7',
          color: '#0072A7',
        },
        6: {
          name: 'Class 6',
          color: '#0092D6',
        },
        5: {
          name: 'Class 5',
          color: '#24B8FC',
        },
        4: {
          name: 'Class 4',
          color: '#5BCBFC',
        },
        3: {
          name: 'Class 3',
          color: '#A4E3FE',
        },
        2: {
          name: 'Class 2',
          color: '#DDF5FF',
        },
      };

      const asArray = Object.entries(selectedVehicleData);
      const filtered = asArray.filter(([key]) => key !== 'vehicle_vocation');
      const filteredObj = Object.fromEntries(filtered);

      const vehicleClassArr = [];

      Object.keys(filteredObj).forEach((vehicleClass) => {
        const vehicleObj = {};
        const colorObj = classChart[vehicleClass];
        vehicleObj.name = colorObj.name;
        vehicleObj.data = filteredObj[vehicleClass];
        vehicleObj.color = colorObj.color;

        vehicleClassArr.push(vehicleObj);
      });
      state.vehicleChartData = vehicleClassArr;
      state.vehicleCategories = vehicleTypes;
    },
  },
  actions: {
    async fetchVehicleData({ commit, getters }) {
      commit('setLoadingVehicleChart', true);
      const queryType = getters.getSelectedVehicleType;
      const dataFilter = getters.getDataType;
      const options = {
        api_key: import.meta.env.VUE_APP_NREL_API_KEY,
      };
      try {
        const response = await ky.get(`${import.meta.env.BASE_URL}vehicle_data.json`, options).json();
        commit('setVehicleData', { data: response, query: queryType, dataType: dataFilter });
      } catch (e) {
        commit('setLoadingVehicleChart', false);
        // eslint-disable-next-line no-console
        console.log(e);
      } finally {
        commit('setLoadingVehicleChart', false);
      }
    },
  },
};
